<simple-table-pds3 #table class="wk-data-table__virtual-container" flowClass="wk-data-table__container">
    <div #header class="wk-data-table__virtual-header">
        <table wk-data-table-header></table>
    </div>
    @if (!dataTableDraggingService.isDragging()) {
        @if (items()?.length > 0) {
            <cdk-virtual-scroll-viewport
                #viewport
                [itemSize]="rowHeight()"
                class="viewport fancy-scrollbar-newUI"
                [minBufferPx]="200"
                [maxBufferPx]="600"
            >
                <table #tableRow *cdkVirtualFor="let item of items(); let index = index; trackBy: trackByPrimaryField">
                    <tbody class="wk-data-table__body">
                        <tr wk-data-table-item [index]="index"></tr>
                    </tbody>
                </table>
            </cdk-virtual-scroll-viewport>
        } @else {
            <cdk-virtual-scroll-viewport
                #viewport
                [itemSize]="rowHeight()"
                class="viewport fancy-scrollbar-newUI"
                [minBufferPx]="200"
                [maxBufferPx]="600"
            >
                <table>
                    <tbody class="wk-data-table__body">
                        <tr wk-data-table-item [empty]="true"></tr>
                    </tbody>
                </table>
            </cdk-virtual-scroll-viewport>
        }
    }
</simple-table-pds3>
